var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { loadActiveAccount, refreshKeys, } from '@popup/steem/actions/active-account.actions';
import { setProcessingDecryptAccount } from '@popup/steem/actions/app-status.actions';
import AccountUtils from '@popup/steem/utils/account.utils';
import { KeyType } from 'src/interfaces/keys.interface';
import { SteemActionType } from './action-type.enum';
export const retrieveAccounts = (mk) => (dispatch, getState) => __awaiter(void 0, void 0, void 0, function* () {
    let accounts = yield AccountUtils.getAccountsFromLocalStorage(mk);
    const action = {
        type: SteemActionType.SET_ACCOUNTS,
        payload: accounts,
    };
    if (accounts) {
        dispatch(action);
        dispatch(setProcessingDecryptAccount(false));
    }
});
export const addAccount = (account) => {
    return {
        type: SteemActionType.ADD_ACCOUNT,
        payload: account,
    };
};
export const resetAccount = () => {
    return {
        type: SteemActionType.RESET_ACCOUNT,
    };
};
//export const setAccounts = (accounts: LocalAccount[]) => {
//  return {
//    type: SteemActionType.SET_ACCOUNTS,
//    payload: accounts,
//  };
//};
export const setAccounts = (accounts) => {
    // // console.log('[AccountActions] Setting accounts:', accounts);
    return {
        type: SteemActionType.SET_ACCOUNTS,
        payload: accounts || [], // Usa array vuoto se undefined
    };
};
export const addKey = (privateKey, keyType, setErrorMessage) => (dispatch, getState) => __awaiter(void 0, void 0, void 0, function* () {
    const { steem: { activeAccount, accounts }, mk, } = getState();
    let newAccounts;
    try {
        newAccounts = yield AccountUtils.addKey(activeAccount, accounts, privateKey, keyType, mk);
    }
    catch (err) {
        setErrorMessage(err.message);
    }
    if (newAccounts && (newAccounts === null || newAccounts === void 0 ? void 0 : newAccounts.length) > 0) {
        const activeLocalAccount = newAccounts.find((account) => account.name === activeAccount.name);
        const action = {
            type: SteemActionType.SET_ACCOUNTS,
            payload: newAccounts,
        };
        dispatch(action);
        dispatch(refreshKeys(activeLocalAccount));
    }
});
export const removeKey = (type) => (dispatch, getState) => __awaiter(void 0, void 0, void 0, function* () {
    const { steem: { activeAccount, accounts }, mk, } = getState();
    const activeLocalAccount = accounts.find((account) => account.name === activeAccount.name);
    let newAccounts = AccountUtils.deleteKey(type, accounts, activeAccount, mk);
    const finalAccounts = [];
    for (let i = 0; i < newAccounts.length; i++) {
        let tmp = newAccounts[i];
        if (type === KeyType.ACTIVE &&
            tmp.keys.activePubkey === `@${activeAccount.name}`) {
            delete tmp.keys.activePubkey;
            delete tmp.keys.active;
        }
        if (type === KeyType.POSTING &&
            tmp.keys.postingPubkey === `@${activeAccount.name}`) {
            delete tmp.keys.posting;
            delete tmp.keys.postingPubkey;
        }
        if (type === KeyType.MEMO &&
            tmp.keys.memoPubkey === `@${activeAccount.name}`) {
            delete tmp.keys.memo;
            delete tmp.keys.memoPubkey;
        }
        newAccounts[i] = tmp;
        if (Object.keys(newAccounts[i].keys).length > 0) {
            finalAccounts.push(newAccounts[i]);
        }
    }
    const action = {
        type: SteemActionType.SET_ACCOUNTS,
        payload: finalAccounts,
    };
    dispatch(action);
    if (finalAccounts) {
        if (finalAccounts
            .map((account) => account.name)
            .includes(activeLocalAccount.name)) {
            const updated = finalAccounts.filter((account) => account.name === activeLocalAccount.name);
            dispatch(refreshKeys(updated[0]));
        }
        else {
            dispatch(loadActiveAccount(accounts[0]));
        }
    }
});
